(function () {
  'use strict';

  function qs(root, selector) { return (root || document).querySelector(selector); }
  function qsa(root, selector) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }
  function centsToMoney(cents) {
    cents = parseInt(cents || 0, 10) || 0;
    var dollars = cents / 100;
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try { return Shopify.formatMoney(cents, window.money_format || '${{amount_no_decimals}}'); } catch (e) {}
    }
    return '$' + (dollars % 1 ? dollars.toFixed(2) : dollars.toFixed(0));
  }



  function getVisibleBaseCards(grid) {
    return qsa(grid, '[data-ll-carousel-card]').filter(function (card) {
      return !card.hidden && card.offsetParent !== null;
    });
  }

  function getBaseCardLeft(grid, card) {
    return Math.max(0, card.offsetLeft - grid.offsetLeft);
  }

  function updateBaseCarouselControls(grid, controls) {
    if (!grid || !controls) return;
    var visibleCards = getVisibleBaseCards(grid);
    var showControls = visibleCards.length > 2;
    controls.hidden = !showControls;
    controls.classList.toggle('is-hidden', !showControls);
    if (!showControls) return;
    var track = controls.querySelector('[data-ll-base-scroll-track]');
    var thumb = controls.querySelector('[data-ll-base-scroll-thumb]');
    var prev = controls.querySelector('[data-ll-base-scroll-prev]');
    var next = controls.querySelector('[data-ll-base-scroll-next]');
    var max = Math.max(0, grid.scrollWidth - grid.clientWidth);
    var progress = max ? (grid.scrollLeft / max) : 0;
    var thumbWidth = grid.scrollWidth ? Math.max(18, Math.min(100, (grid.clientWidth / grid.scrollWidth) * 100)) : 100;

    if (thumb) {
      thumb.style.width = thumbWidth + '%';
      thumb.style.left = (progress * (100 - thumbWidth)) + '%';
    }

    if (prev) prev.disabled = grid.scrollLeft <= 2;
    if (next) next.disabled = grid.scrollLeft >= max - 2;
    if (track) track.classList.toggle('is-static', max <= 2);
  }

  function selectBaseGridByCard(grid, direction) {
    var cards = getVisibleBaseCards(grid);
    if (!cards.length) return;

    var currentIndex = getSelectedBaseCardIndex(grid, cards);

    var nextIndex = Math.max(0, Math.min(cards.length - 1, currentIndex + direction));
    var nextCard = cards[nextIndex];
    var nextInput = nextCard ? qs(nextCard, 'input[data-ll-addon-radio]') : null;

    if (nextInput && !nextInput.disabled) {
      nextInput.checked = true;
      try { nextInput.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
    }

    if (nextCard) {
      var nextLeft = getBaseCardLeft(grid, nextCard);
      grid.scrollTo({
        left: nextLeft,
        behavior: 'smooth'
      });

      var block = grid.closest('[data-ll-carousel-block]');
      updateBaseNativeControls(block);
    }
  }

  function initBaseCarouselControls(root) {
    qsa(root || document, '[data-ll-lightbase-block]').forEach(function (block) {
      var grid = qs(block, '.ll-cfg-base-grid');
      if (!grid || grid.getAttribute('data-ll-base-controls-ready')) return;
      grid.setAttribute('data-ll-base-controls-ready', 'true');

      var controls = document.createElement('div');
      controls.className = 'll-base-scroll-controls';
      controls.innerHTML = [
        '<button type="button" class="ll-base-scroll-btn" data-ll-base-scroll-prev aria-label="Previous light base">‹</button>',
        '<div class="ll-base-scroll-track" data-ll-base-scroll-track aria-hidden="true"><span data-ll-base-scroll-thumb></span></div>',
        '<button type="button" class="ll-base-scroll-btn" data-ll-base-scroll-next aria-label="Next light base">›</button>'
      ].join('');

      grid.insertAdjacentElement('afterend', controls);

      var prev = controls.querySelector('[data-ll-base-scroll-prev]');
      var next = controls.querySelector('[data-ll-base-scroll-next]');

      if (prev) prev.addEventListener('click', function () { selectBaseGridByCard(grid, -1); });
      if (next) next.addEventListener('click', function () { selectBaseGridByCard(grid, 1); });

      grid.addEventListener('scroll', function () { updateBaseCarouselControls(grid, controls); }, { passive: true });
      window.addEventListener('resize', function () { updateBaseCarouselControls(grid, controls); }, { passive: true });

      setTimeout(function () { updateBaseCarouselControls(grid, controls); }, 60);
    });
  }


  function getSelectedBaseCardIndex(grid, cards) {
    var checked = qs(grid, 'input[data-ll-addon-radio]:checked');
    if (!checked) return 0;

    var currentCard = checked.closest('[data-ll-carousel-card]');
    var foundIndex = cards.indexOf(currentCard);
    return foundIndex >= 0 ? foundIndex : -1;
  }

  function updateBaseNativeControls(block) {
    if (!block) return;
    var grid = qs(block, '.ll-cfg-base-grid');
    var controls = qs(block, '.ll-base-native-controls');
    if (!grid || !controls) return;

    var cards = getVisibleBaseCards(grid);
    var selectedIndex = getSelectedBaseCardIndex(grid, cards);
    var prev = qs(controls, '[data-ll-base-native-prev]');
    var next = qs(controls, '[data-ll-base-native-next]');
    var track = qs(controls, '[data-ll-base-slider-track]');
    var thumb = qs(controls, '[data-ll-base-slider-thumb]');
    var hasChoices = cards.length > 2;
    var maxScroll = Math.max(0, grid.scrollWidth - grid.clientWidth);
    var progress = maxScroll ? (grid.scrollLeft / maxScroll) : 0;
    var thumbWidth = maxScroll ? Math.max(22, Math.min(70, (grid.clientWidth / grid.scrollWidth) * 100)) : 100;

    controls.hidden = !hasChoices;
    controls.classList.toggle('is-hidden', !hasChoices);

    if (prev) prev.disabled = !hasChoices || selectedIndex <= 0;
    if (next) next.disabled = !hasChoices || selectedIndex >= cards.length - 1;

    if (track) track.classList.toggle('is-static', maxScroll <= 2);
    if (thumb) {
      thumb.style.width = thumbWidth + '%';
      thumb.style.left = (progress * (100 - thumbWidth)) + '%';
    }
  }

  /* Stage 7AC: direct click/tap selection for light-base and accessory cards.
     Do not rely on the legacy theme's implicit <label> -> hidden radio behavior,
     which is unreliable inside these horizontal mobile carousels. */
  function activateCarouselCard(card) {
    if (!card || card.hidden || card.classList.contains('is-hidden') || card.classList.contains('is-unavailable')) return false;

    var input = qs(card, 'input[data-ll-addon-radio]');
    if (!input || input.disabled) return false;

    if (!input.checked) {
      input.checked = true;
      try { input.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
    } else {
      var block = card.closest('[data-ll-carousel-block]');
      if (block) updateBaseNativeControls(block);
    }
    return true;
  }

  function initCarouselCardTapSelection(root) {
    qsa(root || document, '[data-ll-carousel-block]').forEach(function (block) {
      if (block.getAttribute('data-ll-card-tap-ready')) return;
      block.setAttribute('data-ll-card-tap-ready', 'true');

      qsa(block, '[data-ll-carousel-card]').forEach(function (card) {
        card.addEventListener('click', function (event) {
          if (event && event.target && event.target.closest && event.target.closest('a, button')) return;
          if (event) event.preventDefault();
          activateCarouselCard(card);
        });
      });
    });
  }

  function initBaseNativeControls(root) {
    qsa(root || document, '[data-ll-carousel-block]').forEach(function (block) {
      var grid = qs(block, '.ll-cfg-base-grid');
      if (!grid || block.getAttribute('data-ll-native-base-controls-ready')) return;

      block.setAttribute('data-ll-native-base-controls-ready', 'true');
      var carouselLabel = block.getAttribute('data-ll-carousel-label') || 'option';

      var controls = document.createElement('div');
      controls.className = 'll-base-native-controls';
      controls.innerHTML = [
        '<button type="button" class="ll-base-native-btn" data-ll-base-native-prev aria-label="Previous ' + carouselLabel + '">‹</button>',
        '<div class="ll-base-slider-track" data-ll-base-slider-track aria-label="' + carouselLabel + ' slider" role="slider" tabindex="0"><span class="ll-base-slider-thumb" data-ll-base-slider-thumb></span></div>',
        '<button type="button" class="ll-base-native-btn" data-ll-base-native-next aria-label="Next ' + carouselLabel + '">›</button>'
      ].join('');

      grid.insertAdjacentElement('afterend', controls);

      var prev = qs(controls, '[data-ll-base-native-prev]');
      var next = qs(controls, '[data-ll-base-native-next]');

      if (prev) prev.addEventListener('click', function () {
        selectBaseGridByCard(grid, -1);
        setTimeout(function () { updateBaseNativeControls(block); }, 180);
      });

      if (next) next.addEventListener('click', function () {
        selectBaseGridByCard(grid, 1);
        setTimeout(function () { updateBaseNativeControls(block); }, 180);
      });

      var track = qs(controls, '[data-ll-base-slider-track]');
      var dragging = false;

      function setScrollFromClientX(clientX) {
        if (!track) return;
        var rect = track.getBoundingClientRect();
        var maxScroll = Math.max(0, grid.scrollWidth - grid.clientWidth);
        if (!maxScroll || !rect.width) return;

        var ratio = (clientX - rect.left) / rect.width;
        ratio = Math.max(0, Math.min(1, ratio));
        grid.scrollLeft = ratio * maxScroll;
        updateBaseNativeControls(block);
      }

      if (track) {
        track.addEventListener('pointerdown', function (event) {
          dragging = true;
          track.setPointerCapture && track.setPointerCapture(event.pointerId);
          setScrollFromClientX(event.clientX);
          event.preventDefault();
        });

        track.addEventListener('pointermove', function (event) {
          if (!dragging) return;
          setScrollFromClientX(event.clientX);
          event.preventDefault();
        });

        track.addEventListener('pointerup', function (event) {
          dragging = false;
          try { track.releasePointerCapture && track.releasePointerCapture(event.pointerId); } catch (e) {}
        });

        track.addEventListener('pointercancel', function () {
          dragging = false;
        });

        track.addEventListener('keydown', function (event) {
          if (event.key === 'ArrowLeft') {
            selectBaseGridByCard(grid, -1);
            event.preventDefault();
          } else if (event.key === 'ArrowRight') {
            selectBaseGridByCard(grid, 1);
            event.preventDefault();
          }
        });
      }

      grid.addEventListener('scroll', function () { updateBaseNativeControls(block); }, { passive: true });
      window.addEventListener('resize', function () { updateBaseNativeControls(block); }, { passive: true });

      setTimeout(function () { updateBaseNativeControls(block); }, 80);
    });
  }

  function normalizeShapeText(text) {
    return String(text || '')
      .toLowerCase()
      .replace(/&amp;/g, '&')
      .replace(/3d/g, '')
      .replace(/crystals?/g, '')
      .replace(/\(2d\)/g, '2d')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }


  var llBaseThumbCache = {};

  function setBaseThumb(img, src) {
    if (!img || !src) return;
    img.src = src;
    img.classList.add('is-loaded');
  }

  function loadBaseThumbnails(root) {
    qsa(root || document, 'img[data-ll-base-thumb][data-ll-base-handle]').forEach(function (img) {
      var handle = img.getAttribute('data-ll-base-handle') || '';
      if (!handle || img.getAttribute('data-ll-loaded')) return;
      img.setAttribute('data-ll-loaded', 'true');

      if (llBaseThumbCache[handle]) {
        setBaseThumb(img, llBaseThumbCache[handle]);
        return;
      }

      fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (res) { if (!res.ok) throw new Error('missing'); return res.json(); })
        .then(function (product) {
          var src = (product.featured_image && product.featured_image.indexOf('//') === 0) ? ('https:' + product.featured_image) : product.featured_image;
          if (!src && product.images && product.images.length) src = product.images[0];
          if (src && src.indexOf('//') === 0) src = 'https:' + src;
          if (src) {
            llBaseThumbCache[handle] = src;
            setBaseThumb(img, src);
          }
        })
        .catch(function () {});
    });
  }

  var llAccessoryProductCache = {};

  function hydrateAccessoryProducts(root, onUpdate) {
    qsa(root || document, '[data-ll-accessory-card][data-ll-accessory-handle]').forEach(function (card) {
      var handle = card.getAttribute('data-ll-accessory-handle') || '';
      if (!handle || card.getAttribute('data-ll-accessory-hydrating')) return;
      card.setAttribute('data-ll-accessory-hydrating', 'true');

      function applyProduct(product) {
        if (!product) return;
        var variants = product.variants || [];
        var variant = null;
        for (var i = 0; i < variants.length; i += 1) {
          if (!variants[i] || variants[i].available === false) continue;
          if (!variant || (parseInt(variants[i].price || '0', 10) || 0) < (parseInt(variant.price || '0', 10) || 0)) {
            variant = variants[i];
          }
        }
        if (!variant && variants.length) {
          variant = variants[0];
          for (var j = 1; j < variants.length; j += 1) {
            if ((parseInt(variants[j].price || '0', 10) || 0) < (parseInt(variant.price || '0', 10) || 0)) variant = variants[j];
          }
        }
        if (!variant) return;

        var variantId = parseInt(variant.id || '0', 10) || 0;
        var price = parseInt(variant.price || card.getAttribute('data-ll-accessory-fallback-price') || '0', 10) || 0;
        var radio = qs(card, 'input[data-ll-addon-radio]');
        var priceNode = card.querySelector(':scope > span:not(.ll-cfg-base-thumb)');
        var thumb = qs(card, 'img[data-ll-base-thumb]');
        var productImage = product.featured_image || ((product.images && product.images.length) ? product.images[0] : '');
        if (productImage && productImage.indexOf('//') === 0) productImage = 'https:' + productImage;

        if (thumb && productImage) {
          thumb.src = productImage;
          thumb.classList.add('is-loaded');
        }
        if (variantId) card.setAttribute('data-ll-accessory-variant-id', String(variantId));
        card.setAttribute('data-ll-accessory-price', String(price));
        card.setAttribute('data-ll-accessory-size', String(variant.title || variant.option1 || ''));
        if (radio) {
          radio.setAttribute('data-ll-addon-price', String(price));
          radio.disabled = variant.available === false;
        }
        if (priceNode) priceNode.textContent = centsToMoney(price);
        card.classList.toggle('is-unavailable', variant.available === false);
        card.setAttribute('data-ll-accessory-hydrated', 'true');
        if (typeof onUpdate === 'function') onUpdate();
      }

      if (llAccessoryProductCache[handle]) {
        applyProduct(llAccessoryProductCache[handle]);
        return;
      }

      fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
        .then(function (res) { if (!res.ok) throw new Error('missing'); return res.json(); })
        .then(function (product) {
          llAccessoryProductCache[handle] = product;
          applyProduct(product);
        })
        .catch(function () {
          var currentId = parseInt(card.getAttribute('data-ll-accessory-variant-id') || '0', 10) || 0;
          if (!currentId) {
            var radio = qs(card, 'input[data-ll-addon-radio]');
            if (radio) radio.disabled = true;
            card.classList.add('is-unavailable');
          }
        });
    });
  }

  var llBasePreviewEl = null;

  function getBasePreviewEl() {
    if (llBasePreviewEl) return llBasePreviewEl;
    llBasePreviewEl = document.createElement('div');
    llBasePreviewEl.className = 'll-base-hover-preview';
    llBasePreviewEl.innerHTML = '<img alt="">';
    document.body.appendChild(llBasePreviewEl);
    return llBasePreviewEl;
  }

  function positionBasePreview(target, preview) {
    if (!target || !preview || !target.getBoundingClientRect) return;
    var rect = target.getBoundingClientRect();
    var width = preview.offsetWidth || 340;
    var height = preview.offsetHeight || 274;
    var gap = 14;

    var left = rect.left + (rect.width / 2) - (width / 2);
    left = Math.max(12, Math.min(left, window.innerWidth - width - 12));

    var top = rect.top - height - gap;
    if (top < 12) top = rect.bottom + gap;
    top = Math.max(12, Math.min(top, window.innerHeight - height - 12));

    preview.style.left = left + 'px';
    preview.style.top = top + 'px';
  }

  function hideBasePreview() {
    if (!llBasePreviewEl) return;
    llBasePreviewEl.classList.remove('is-visible');
  }

  function getHoverPreviewImage(target) {
    if (!target) return null;
    if (target.matches && target.matches('img[data-ll-hover-preview-image], img[data-ll-base-thumb]')) return target;
    if (!target.querySelector) return null;
    return target.querySelector('img[data-ll-hover-preview-image], img[data-ll-base-thumb]');
  }

  function showBasePreview(target) {
    var img = getHoverPreviewImage(target);
    if (!img || !img.src) return;
    var preview = getBasePreviewEl();
    var previewImg = preview.querySelector('img');
    previewImg.src = img.src;
    previewImg.alt = img.alt || 'Product preview';
    positionBasePreview(target, preview);
    preview.classList.add('is-visible');
  }

  function bindHoverPreviewTarget(target) {
    if (!target || target.getAttribute('data-ll-hover-preview-ready')) return;
    target.setAttribute('data-ll-hover-preview-ready', 'true');

    target.addEventListener('mouseenter', function () { showBasePreview(target); });
    target.addEventListener('mousemove', function () {
      if (llBasePreviewEl && llBasePreviewEl.classList.contains('is-visible')) positionBasePreview(target, llBasePreviewEl);
    });
    target.addEventListener('mouseleave', hideBasePreview);
    target.addEventListener('focusin', function () { showBasePreview(target); });
    target.addEventListener('focusout', hideBasePreview);
  }

  function initBaseThumbHoverPreview(root) {
    qsa(root || document, '.ll-cfg-base-thumb').forEach(bindHoverPreviewTarget);
  }

  function shapeKeyFromText(text) {
    var normalized = normalizeShapeText(text);
    if (!normalized) return '';
    if (normalized.indexOf('tower') !== -1) return 'tower';
    if (normalized.indexOf('brick') !== -1) return 'brick';
    if (normalized.indexOf('pet paw') !== -1 || normalized.indexOf('paw') !== -1) return 'paw';
    if (normalized.indexOf('flat') !== -1 || normalized === '2d') return 'flat';
    if (normalized.indexOf('prestige') !== -1) return 'prestige';
    if (normalized.indexOf('diamond') !== -1) return 'diamond';
    if (normalized.indexOf('square') !== -1) return 'square';
    if (normalized.indexOf('urn') !== -1) return 'urn';
    if (normalized.indexOf('heart') !== -1) return 'heart';
    return '';
  }



  /* Stage 5A: live text engraving preview */
  var ENGRAVING_POSITIONS = {
    tower:    { x: 49.6, y: 83.7, w: 39.3, size: 17.0, lineHeight: 1.16, rotate: 0.0 },
    brick:    { x: 50.0, y: 77.1, w: 46.0, size: 17.0, lineHeight: 1.13, rotate: 0.0 },
    heart:    { x: 50.0, y: 72.2, w: 32.0, size: 15.0, lineHeight: 1.12, rotate: 0.0 },
    prestige: { x: 48.6, y: 86.4, w: 34.0, size: 15.0, lineHeight: 1.12, rotate: 0.0 },
    diamond:  { x: 50.0, y: 70.0, w: 30.0, size: 14.0, lineHeight: 1.12, rotate: 0.0 },
    square:   { x: 50.0, y: 84.2, w: 36.0, size: 17.2, lineHeight: 1.12, rotate: 0.0 },
    urn:      { x: 38.0, y: 76.6, w: 38.0, size: 14.0, lineHeight: 1.12, rotate: 0.0 },
    paw:      { x: 50.0, y: 74.9, w: 40.0, size: 15.0, lineHeight: 1.12, rotate: 0.0 },
    flat:     { x: 50.0, y: 73.9, w: 36.0, size: 17.0, lineHeight: 1.12, rotate: 0.0 },
    default:  { x: 50.0, y: 83.7, w: 39.3, size: 17.0, lineHeight: 1.12, rotate: 0.0 }
  };

  function getEngravingPosition(shapeKey) {
    return ENGRAVING_POSITIONS[shapeKey] || ENGRAVING_POSITIONS.default;
  }

  function isTextCalibrationMode() {
    return false;
  }

  function getActiveEngravingPosition(root, shapeKey) {
    if (root && root.__llTextCalibration && root.__llTextCalibration.shapeKey === shapeKey) {
      return root.__llTextCalibration.values;
    }
    return getEngravingPosition(shapeKey);
  }

  function formatCalibrationValues(shapeKey, values) {
    return shapeKey + ': { x: ' +
      Number(values.x).toFixed(1) + ', y: ' +
      Number(values.y).toFixed(1) + ', w: ' +
      Number(values.w).toFixed(1) + ', size: ' +
      Number(values.size).toFixed(1) + ', lineHeight: ' +
      Number(values.lineHeight || 1.12).toFixed(2) + ', rotate: ' +
      Number(values.rotate || 0).toFixed(1) + ' }';
  }

  function ensureTextCalibrationPanel(root) {
    if (!isTextCalibrationMode() || !root) return null;
    var existing = qs(root, '[data-ll-text-calibration-panel]');
    if (existing) return existing;

    var target = qs(root, '[data-ll-engraving-wrap]') || root;
    var panel = document.createElement('div');
    panel.className = 'll-text-calibration-panel';
    panel.setAttribute('data-ll-text-calibration-panel', '');
    panel.innerHTML =
      '<h4>Text Preview Calibration</h4>' +
      '<p>Visible only with <strong>?ll_text_calibrate=1</strong>. Tune the current shape, then copy the values.</p>' +
      '<div class="ll-text-calibration-grid">' +
        '<div class="ll-text-calibration-control"><label>X <span data-ll-cal-value="x"></span></label><input type="range" min="0" max="100" step="0.1" data-ll-cal="x"></div>' +
        '<div class="ll-text-calibration-control"><label>Y <span data-ll-cal-value="y"></span></label><input type="range" min="0" max="100" step="0.1" data-ll-cal="y"></div>' +
        '<div class="ll-text-calibration-control"><label>Width <span data-ll-cal-value="w"></span></label><input type="range" min="10" max="90" step="0.1" data-ll-cal="w"></div>' +
        '<div class="ll-text-calibration-control"><label>Font <span data-ll-cal-value="size"></span></label><input type="range" min="8" max="32" step="0.1" data-ll-cal="size"></div>' +
        '<div class="ll-text-calibration-control"><label>Line height <span data-ll-cal-value="lineHeight"></span></label><input type="range" min="0.8" max="1.6" step="0.01" data-ll-cal="lineHeight"></div>' +
        '<div class="ll-text-calibration-control"><label>Rotate <span data-ll-cal-value="rotate"></span></label><input type="range" min="-25" max="25" step="0.1" data-ll-cal="rotate"></div>' +
      '</div>' +
      '<div class="ll-text-calibration-values" data-ll-cal-output></div>' +
      '<button type="button" class="ll-text-calibration-copy" data-ll-cal-copy>Copy values</button>';

    target.parentNode.insertBefore(panel, target.nextSibling);
    return panel;
  }

  function syncTextCalibrationPanel(root) {
    var panel = ensureTextCalibrationPanel(root);
    if (!panel) return;
    var shapeKey = getCurrentShapeKey(root);
    var basePos = getEngravingPosition(shapeKey);
    var current = root.__llTextCalibration && root.__llTextCalibration.shapeKey === shapeKey
      ? root.__llTextCalibration.values
      : {
          x: basePos.x || 50,
          y: basePos.y || 85,
          w: basePos.w || 36,
          size: basePos.size || 15,
          lineHeight: basePos.lineHeight || 1.12,
          rotate: basePos.rotate || 0
        };

    root.__llTextCalibration = { shapeKey: shapeKey, values: current };

    qsa(panel, '[data-ll-cal]').forEach(function (input) {
      var key = input.getAttribute('data-ll-cal');
      input.value = current[key];
      if (!input.__llCalibrationBound) {
        input.__llCalibrationBound = true;
        input.addEventListener('input', function () {
          var active = root.__llTextCalibration || { shapeKey: getCurrentShapeKey(root), values: {} };
          var k = input.getAttribute('data-ll-cal');
          active.values[k] = parseFloat(input.value);
          root.__llTextCalibration = active;
          updateMainEngravingPreview(root);
          updateTextCalibrationReadout(root);
        });
      }
    });

    var copy = qs(panel, '[data-ll-cal-copy]');
    if (copy && !copy.__llBound) {
      copy.__llBound = true;
      copy.addEventListener('click', function () {
        var values = formatCalibrationValues(root.__llTextCalibration.shapeKey, root.__llTextCalibration.values);
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(values).catch(function () {});
        }
        copy.textContent = 'Copied';
        setTimeout(function () { copy.textContent = 'Copy values'; }, 900);
      });
    }

    updateTextCalibrationReadout(root);
  }

  function updateTextCalibrationReadout(root) {
    var panel = qs(root, '[data-ll-text-calibration-panel]');
    if (!panel || !root.__llTextCalibration) return;
    var values = root.__llTextCalibration.values;
    Object.keys(values).forEach(function (key) {
      var node = qs(panel, '[data-ll-cal-value="' + key + '"]');
      if (node) node.textContent = Number(values[key]).toFixed(key === 'lineHeight' ? 2 : 1);
    });
    var output = qs(panel, '[data-ll-cal-output]');
    if (output) output.textContent = formatCalibrationValues(root.__llTextCalibration.shapeKey, values);
  }

  function getCurrentShapeKey(root) {
    var current = qs(root, '.ll-cfg-shape.is-selected');
    var key = current ? current.getAttribute('data-ll-shape-key') : '';
    if (!key) key = root.getAttribute('data-ll-current-shape-key') || '';
    if (!key) key = shapeKeyFromText((qs(root, '[data-ll-selected-shape-label]') || {}).textContent || '');
    return key || 'default';
  }

  function ensureMainEngravingOverlay() {
    var gallery = document.querySelector('.ll-configurator-media .detail-gallery') || document.querySelector('.detail-gallery');
    if (!gallery) return null;
    var mid = gallery.querySelector('.mid');
    if (!mid) return null;
    var overlay = mid.querySelector('[data-ll-main-engraving-preview]');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'll-main-engraving-preview';
      overlay.setAttribute('data-ll-main-engraving-preview', '');
      overlay.setAttribute('aria-hidden', 'true');
      overlay.innerHTML = '<div class="ll-main-engraving-preview__text" data-ll-main-engraving-preview-text></div>';
      mid.appendChild(overlay);
    }
    return overlay;
  }

  function normalizeEngravingText(text) {
    return String(text || '').replace(/\r\n/g, '\n').replace(/\r/g, '\n').trim();
  }

  function getEngravingLines(root) {
    var line1Input = qs(root, '[data-ll-engraving-line1]');
    var line2Input = qs(root, '[data-ll-engraving-line2]');
    var line1 = normalizeEngravingText(line1Input ? line1Input.value : '');
    var line2 = normalizeEngravingText(line2Input ? line2Input.value : '');
    return {
      line1: line1,
      line2: line2,
      text: [line1, line2].filter(Boolean).join('\n'),
      length: line1.length + line2.length
    };
  }

  function syncEngravingHiddenInput(root) {
    var hiddenInput = qs(root, '[data-ll-engraving-input]');
    if (!hiddenInput) return '';
    var lines = getEngravingLines(root);
    hiddenInput.value = lines.text;
    return lines.text;
  }

  function updateMainEngravingPreview(root) {
    var overlay = ensureMainEngravingOverlay();
    if (!overlay) return;
    var textNode = qs(overlay, '[data-ll-main-engraving-preview-text]');
    var gallery = document.querySelector('.ll-configurator-media .detail-gallery') || document.querySelector('.detail-gallery');
    var toggle = qs(root, '[data-ll-engraving-toggle]');
    var enabled = !!(toggle && toggle.checked);
    var lines = getEngravingLines(root);
    var text = lines.text;
    var hasSavedPreview = !!(gallery && gallery.classList.contains('ll-has-upload-preview'));

    if (!enabled || !text || !hasSavedPreview) {
      overlay.classList.remove('is-visible');
      overlay.setAttribute('hidden', '');
      if (textNode) textNode.textContent = '';
      return;
    }

    var shapeKey = getCurrentShapeKey(root);
    var pos = getEngravingPosition(shapeKey);
    var lengthPenalty = Math.max(0, Math.min(4, Math.floor((lines.length - 18) / 10)));
    var fontSize = Math.max(12, (pos.size || 15) - lengthPenalty);

    overlay.style.setProperty('--ll-engraving-x', String(pos.x || 50) + '%');
    overlay.style.setProperty('--ll-engraving-y', String(pos.y || 85) + '%');
    overlay.style.setProperty('--ll-engraving-width', String(pos.w || 42) + '%');
    overlay.style.setProperty('--ll-engraving-rotate', String(pos.rotate || 0) + 'deg');
    overlay.style.setProperty('--ll-engraving-font-size', String(fontSize) + 'px');
    overlay.style.setProperty('--ll-engraving-line-height', String(pos.lineHeight || 1.12));
    overlay.setAttribute('data-ll-shape', shapeKey);
    overlay.removeAttribute('hidden');
    overlay.classList.add('is-visible');
    if (textNode) textNode.textContent = text;
  }

  function findHeaderShapeUrl(shapeKey) {
    var candidates = Array.prototype.slice.call(document.querySelectorAll('a[href*="/products/"]'));
    var best = '';

    candidates.some(function (link) {
      if (link.closest('[data-ll-configurator]')) return false;
      var key = shapeKeyFromText(link.textContent || '');
      if (key === shapeKey) {
        best = link.getAttribute('href') || link.href || '';
        return true;
      }
      return false;
    });

    if (best) return best;

    candidates.some(function (link) {
      if (link.closest('[data-ll-configurator]')) return false;
      var href = (link.getAttribute('href') || link.href || '').toLowerCase();
      if (!href) return false;
      if (shapeKey === 'tower' && href.indexOf('crystal-tower') !== -1) best = link.getAttribute('href') || link.href;
      else if (shapeKey === 'brick' && href.indexOf('crystal-brick') !== -1) best = link.getAttribute('href') || link.href;
      else if (shapeKey === 'heart' && href.indexOf('crystal-heart') !== -1) best = link.getAttribute('href') || link.href;
      else if (shapeKey === 'prestige' && href.indexOf('crystal-prestige') !== -1) best = link.getAttribute('href') || link.href;
      else if (shapeKey === 'diamond' && href.indexOf('crystal-diamond') !== -1) best = link.getAttribute('href') || link.href;
      else if (shapeKey === 'square' && href.indexOf('square-crystal') !== -1) best = link.getAttribute('href') || link.href;
      else if (shapeKey === 'urn' && href.indexOf('urn-crystal') !== -1) best = link.getAttribute('href') || link.href;
      else if (shapeKey === 'paw' && href.indexOf('paw') !== -1) best = link.getAttribute('href') || link.href;
      else if (shapeKey === 'flat' && href.indexOf('flat') !== -1) best = link.getAttribute('href') || link.href;
      return !!best;
    });

    return best;
  }

  var LL_SHAPE_PHOTO_TRANSFER_SESSION_KEY = 'll-shape-photo-transfer-v1';
  var LL_SHAPE_PHOTO_TRANSFER_MAX_AGE = 30 * 60 * 1000;

  function savePendingShapePhotoTransfer(targetShape, photoMetadata) {
    try {
      window.sessionStorage.setItem(LL_SHAPE_PHOTO_TRANSFER_SESSION_KEY, JSON.stringify({
        version: 1,
        targetShape: targetShape || '',
        createdAt: Date.now(),
        photo: photoMetadata || null
      }));
    } catch (e) {}
  }

  function readPendingShapePhotoTransfer() {
    var raw = '';
    try { raw = window.sessionStorage.getItem(LL_SHAPE_PHOTO_TRANSFER_SESSION_KEY) || ''; }
    catch (e) { return null; }
    if (!raw) return null;
    try { return JSON.parse(raw); }
    catch (e) { return null; }
  }

  function clearPendingShapePhotoTransfer() {
    try { window.sessionStorage.removeItem(LL_SHAPE_PHOTO_TRANSFER_SESSION_KEY); }
    catch (e) {}
  }

  function buildPreviewSafeUrl(rawUrl) {
    var dest;
    try { dest = new URL(rawUrl || '/', window.location.origin); }
    catch (e) { dest = new URL('/', window.location.origin); }

    // Preserve Shopify unpublished-theme preview parameters. Without these,
    // Shopify can drop the visitor back into the live/old theme, which looks
    // like a broken page even when the product handle is valid.
    var preserveExact = {
      preview_theme_id: true,
      pb: true,
      _fd: true,
      _ab: true,
      key: true,
      locale: true,
      market: true
    };
    var current = new URL(window.location.href);
    current.searchParams.forEach(function (value, key) {
      if (key === 'variant') return;
      if (preserveExact[key] || key.indexOf('preview') !== -1 || key.indexOf('utm_') === 0) {
        if (!dest.searchParams.has(key)) dest.searchParams.set(key, value);
      }
    });

    return dest.toString();
  }

  function initConfigurator(root) {
    var form = root.closest('form');
    if (!form) return;
    var select = qs(form, '#productSelect');
    var qtyCart = qs(form, '.qty-cart');
    var priceNode = document.querySelector('.enj-product-price');
    var compareNode = document.querySelector('.enj-product-price-compare');
    var activeVariantCents = 0;
    var personalizeBtn = qs(root, '[data-ll-personalize-trigger]');
    var personalizeLabel = qs(root, '[data-ll-personalize-label]');
    var photoStatus = qs(root, '[data-ll-photo-status]');
    var photoStatusText = qs(root, '[data-ll-photo-status-text]');
    var editPhotoAgain = qs(root, '[data-ll-edit-photo-again]');
    var shapeInput = qs(root, '[data-ll-selected-shape-input]');
    var selectedShapeLabel = qs(root, '[data-ll-selected-shape-label]');
    var sizeInput = qs(root, '[data-ll-selected-size-input]');
    var sizePriceInput = qs(root, '[data-ll-selected-size-price-input]');
    var totalPropertyInput = qs(root, '[data-ll-total-property]');
    var addonTotalPropertyInput = qs(root, '[data-ll-addon-total-property]');
    var panel = root.closest('.ll-configurator-panel');
    var page = root.closest('.ll-product-configurator-page');
    var photoFlowReady = false;

    function setPhotoFlowReady(ready) {
      photoFlowReady = !!ready;
      root.classList.toggle('ll-cfg-photo-ready', photoFlowReady);
      root.classList.toggle('ll-cfg-awaiting-photo', !photoFlowReady);
      if (panel) {
        panel.classList.toggle('ll-flow-photo-ready', photoFlowReady);
        panel.classList.toggle('ll-flow-awaiting-photo', !photoFlowReady);
      }
      if (page) {
        page.classList.toggle('ll-flow-photo-ready', photoFlowReady);
        page.classList.toggle('ll-flow-awaiting-photo', !photoFlowReady);
      }
      setCollapseState(photoFlowReady);
    }

    setPhotoFlowReady(false);
    loadBaseThumbnails(root);
    initBaseThumbHoverPreview(root);
    initBaseNativeControls(root);
    initCarouselCardTapSelection(root);
    var lightBaseBlock = qs(root, '[data-ll-lightbase-block]');
    var lightBaseNoneInput = qs(root, '[data-ll-lightbase-none-input]');
    var removeLightBaseButton = qs(root, '[data-ll-remove-lightbase]');
    var accessoryBlock = qs(root, '[data-ll-accessory-upsell]');
    var accessoryCustomizer = qs(root, '[data-ll-accessory-customizer]');
    var accessoryEditorRoot = qs(root, '[data-ll-editor-secondary="true"]');
    var mainEditorRoot = qs(root, '[data-ll-image-editor]:not([data-ll-editor-secondary="true"])');
    var accessoryCustomizeButton = qs(root, '[data-ll-accessory-customize]');
    var accessoryCustomizeLabel = qs(root, '[data-ll-accessory-customize-label]');
    var accessoryCustomizeStatus = qs(root, '[data-ll-accessory-customize-status]');
    var accessorySavedWrap = qs(root, '[data-ll-accessory-saved]');
    var accessorySavedList = qs(root, '[data-ll-accessory-saved-list]');
    var accessorySavedCount = qs(root, '[data-ll-accessory-saved-count]');
    var accessoryItems = [];
    root.__llAccessoryItems = accessoryItems;
    var activeAccessoryKey = '';
    var accessorySaved = false;
    var collapse = qs(root, '[data-ll-collapse]');
    var collapseToggle = qs(root, '[data-ll-collapse-toggle]');
    var collapsePanel = qs(root, '[data-ll-collapse-panel]');

    function setCollapseState(open) {
      if (!collapse || !collapseToggle || !collapsePanel) return;
      collapse.classList.toggle('is-open', !!open);
      collapse.classList.toggle('is-collapsed', !open);
      collapseToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      collapsePanel.hidden = !open;
    }

    if (collapse && collapseToggle && collapsePanel) {
      setCollapseState(false);
      collapseToggle.setAttribute('aria-disabled', 'true');
      collapseToggle.setAttribute('tabindex', '-1');
    }

    function getAddonCents() {
      var addon = 0;
      qsa(root, '[data-ll-addon]').forEach(function (input) {
        if (input.checked) addon += parseInt(input.getAttribute('data-ll-addon-price') || '0', 10) || 0;
      });
      qsa(root, '[data-ll-addon-radio]').forEach(function (input) {
        if (input.closest('[data-ll-accessory-upsell]')) return;
        if (input.checked) addon += parseInt(input.getAttribute('data-ll-addon-price') || '0', 10) || 0;
      });
      accessoryItems.forEach(function (item) {
        addon += parseInt(item.price || '0', 10) || 0;
      });
      return addon;
    }

    function updateTotal() {
      var addonTotal = getAddonCents();
      var total = activeVariantCents + addonTotal;
      if (qtyCart) qtyCart.setAttribute('data-ll-total-label', centsToMoney(total));
      if (totalPropertyInput) totalPropertyInput.value = centsToMoney(total);
      if (addonTotalPropertyInput) addonTotalPropertyInput.value = centsToMoney(addonTotal);
    }

    hydrateAccessoryProducts(root, updateTotal);
    function getExplicitBaseCompatibility(sizeButton) {
      var shapeKey = (root.getAttribute('data-ll-current-shape-key') || root.getAttribute('data-ll-current-shape') || '').toLowerCase();
      var sizeLabel = (sizeButton.getAttribute('data-ll-size-label') || '').replace(/\s+/g, '').toLowerCase();

      var matrix = {
        brick: {
          small: ['round'],
          medium: ['wood-medium'],
          large: ['wood-large'],
          xlarge: ['wood-large'],
          xxlarge: ['wood-xlarge'],
          '3xlarge': [],
          '4xlarge': [],
          '5xlarge': [],
          '6xlarge': []
        },
        paw: {
          small: ['wood-small'],
          medium: ['wood-medium'],
          large: ['wood-medium']
        },
        heart: {
          small: ['round', 'wood-small'],
          medium: ['round', 'wood-small'],
          large: ['round', 'wood-medium']
        }
      };

      if (matrix[shapeKey] && Object.prototype.hasOwnProperty.call(matrix[shapeKey], sizeLabel)) {
        return matrix[shapeKey][sizeLabel].slice();
      }
      return null;
    }

    function updateBaseCompatibility(sizeButton) {
      if (!lightBaseBlock || !sizeButton) return;
      var explicit = getExplicitBaseCompatibility(sizeButton);
      var raw = sizeButton.getAttribute('data-ll-compatible-bases') || '';
      var allowed = explicit !== null
        ? explicit
        : raw.split(',').map(function (item) { return item.trim(); }).filter(Boolean);
      var hasBases = allowed.length > 0;
      var noneInput = lightBaseNoneInput || qs(lightBaseBlock, '[data-ll-lightbase-none-input]');

      lightBaseBlock.hidden = !hasBases;
      lightBaseBlock.classList.toggle('is-hidden', !hasBases);

      qsa(lightBaseBlock, '[data-ll-base-card]').forEach(function (card) {
        var key = card.getAttribute('data-ll-base-card') || '';
        var input = qs(card, 'input');
        var visible = key === 'none' || allowed.indexOf(key) !== -1;
        card.hidden = !visible;
        card.classList.toggle('is-hidden', !visible);
        if (input) {
          input.disabled = !visible;
        }
      });

      var checked = qs(lightBaseBlock, 'input[data-ll-addon-radio]:checked');
      if (!hasBases || !checked || checked.disabled || (checked.closest('[data-ll-base-card]') && checked.closest('[data-ll-base-card]').hidden)) {
        if (noneInput) {
          noneInput.checked = true;
          try { noneInput.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
        }
      }
      syncOptionSelectedStates();
      updateBaseNativeControls(lightBaseBlock);
    }

    function selectVariant(button) {
      if (!button || button.disabled) return;
      var id = button.getAttribute('data-ll-variant-id');
      var label = button.getAttribute('data-ll-size-label') || button.textContent.trim();
      activeVariantCents = parseInt(button.getAttribute('data-ll-variant-price') || '0', 10) || 0;
      if (select && id) {
        select.value = id;
        try { select.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) { if (window.jQuery) jQuery(select).trigger('change'); }
      }
      if (sizeInput) sizeInput.value = label;
      if (sizePriceInput) sizePriceInput.value = centsToMoney(activeVariantCents);
      qsa(root, '.ll-cfg-size').forEach(function (btn) {
        var selected = btn === button;
        btn.classList.toggle('is-selected', selected);
        btn.setAttribute('aria-checked', selected ? 'true' : 'false');
      });
      if (priceNode) priceNode.textContent = centsToMoney(activeVariantCents);
      var compare = parseInt(button.getAttribute('data-ll-variant-compare') || '0', 10) || 0;
      if (compareNode) {
        compareNode.textContent = compare > activeVariantCents ? centsToMoney(compare) : '';
        compareNode.style.display = compare > activeVariantCents ? '' : 'none';
      }
      updateBaseCompatibility(button);
      updateTotal();
    }

    var initialSizeButton = null;
    qsa(root, '.ll-cfg-size').forEach(function (btn) {
      btn.addEventListener('click', function () { selectVariant(btn); });
      if (btn.classList.contains('is-selected')) {
        initialSizeButton = btn;
        activeVariantCents = parseInt(btn.getAttribute('data-ll-variant-price') || '0', 10) || 0;
        if (sizeInput) sizeInput.value = btn.getAttribute('data-ll-size-label') || btn.textContent.trim();
        if (sizePriceInput) sizePriceInput.value = centsToMoney(activeVariantCents);
      }
    });
    if (initialSizeButton) {
      updateBaseCompatibility(initialSizeButton);
    }

    qsa(root, '[data-ll-shape-choice]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var label = btn.getAttribute('data-ll-shape-choice') || '';
        var key = btn.getAttribute('data-ll-shape-key') || shapeKeyFromText(label);
        if (shapeInput) shapeInput.value = label;
        if (selectedShapeLabel) selectedShapeLabel.textContent = label;
        root.setAttribute('data-ll-current-shape-key', key || '');
        updateMainEngravingPreview(root);

        if (btn.classList.contains('is-selected')) return;

        var menuUrl = findHeaderShapeUrl(key);
        var fallbackUrl = btn.getAttribute('data-ll-fallback-url') || '';
        var targetUrl = menuUrl || fallbackUrl;

        if (!targetUrl || targetUrl === '#') {
          console.warn('[LL configurator] No product URL found for shape:', key, label);
          return;
        }

        function navigateToSelectedShape() {
          window.location.assign(buildPreviewSafeUrl(targetUrl));
        }

        var hasTransferablePhoto = !!(mainEditorRoot && (
          photoFlowReady ||
          (typeof mainEditorRoot.__llHasTransferableMainPhoto === 'function' && mainEditorRoot.__llHasTransferableMainPhoto())
        ));

        if (!hasTransferablePhoto || typeof mainEditorRoot.__llPrepareMainPhotoTransfer !== 'function') {
          navigateToSelectedShape();
          return;
        }

        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        mainEditorRoot.__llPrepareMainPhotoTransfer().then(function (photoMetadata) {
          savePendingShapePhotoTransfer(key, photoMetadata);
        }).catch(function (err) {
          console.warn('[LL configurator] The photo could not be prepared for shape transfer:', err);
        }).then(function () {
          navigateToSelectedShape();
        });
      });
    });

    function getSelectedAccessoryCard() {
      var selectedRadio = accessoryBlock ? qs(accessoryBlock, 'input[data-ll-addon-radio]:checked') : null;
      return selectedRadio ? selectedRadio.closest('[data-ll-accessory-card]') : null;
    }

    function getAccessoryEditorValue(selector, fallback) {
      var input = accessoryEditorRoot ? qs(accessoryEditorRoot, selector) : null;
      return input && input.value != null && input.value !== '' ? String(input.value) : String(fallback || '');
    }

    function updateAccessoryRegistry() {
      root.__llAccessoryItems = accessoryItems.slice();
    }

    function renderAccessoryItems() {
      updateAccessoryRegistry();
      if (accessorySavedWrap) accessorySavedWrap.hidden = accessoryItems.length === 0;
      if (accessorySavedCount) accessorySavedCount.textContent = accessoryItems.length + (accessoryItems.length === 1 ? ' item' : ' items');
      if (!accessorySavedList) {
        updateTotal();
        return;
      }

      accessorySavedList.innerHTML = '';
      accessoryItems.forEach(function (item) {
        var row = document.createElement('div');
        row.className = 'll-cfg-accessory-item';
        row.setAttribute('data-ll-accessory-item-id', item.id);

        var previewButton = document.createElement('button');
        previewButton.type = 'button';
        previewButton.className = 'll-cfg-accessory-item__preview';
        previewButton.setAttribute('aria-label', 'View larger preview of ' + item.name);

        var image = document.createElement('img');
        image.src = item.previewUrl;
        image.alt = item.name + ' customized preview';
        image.setAttribute('data-ll-hover-preview-image', 'true');
        previewButton.appendChild(image);
        bindHoverPreviewTarget(previewButton);

        var copy = document.createElement('div');
        copy.className = 'll-cfg-accessory-item__copy';
        var title = document.createElement('strong');
        title.textContent = item.name;
        var detail = document.createElement('small');
        detail.textContent = centsToMoney(item.price) + (item.size ? ' · ' + item.size : '') + ' · Customized and ready';
        copy.appendChild(title);
        copy.appendChild(detail);

        var remove = document.createElement('button');
        remove.type = 'button';
        remove.className = 'll-cfg-accessory-item__remove';
        remove.textContent = 'Remove';
        remove.setAttribute('aria-label', 'Remove ' + item.name);
        remove.addEventListener('click', function () {
          accessoryItems = accessoryItems.filter(function (savedItem) { return savedItem.id !== item.id; });
          if (!accessoryItems.length) {
            accessorySaved = false;
            if (accessoryCustomizeLabel) accessoryCustomizeLabel.textContent = 'Customize Accessory';
          }
          renderAccessoryItems();
          var selectedCard = getSelectedAccessoryCard();
          var noSelection = !selectedCard || selectedCard.getAttribute('data-ll-accessory-card') === 'none';
          if (accessoryCustomizeStatus) {
            accessoryCustomizeStatus.textContent = noSelection
              ? (accessoryItems.length ? 'Saved accessories remain below. Select an accessory to add another.' : 'Select an accessory above to customize it.')
              : 'Customize ' + (selectedCard.getAttribute('data-ll-accessory-title') || 'this accessory') + ' to add another item.';
          }
        });

        row.appendChild(previewButton);
        row.appendChild(copy);
        row.appendChild(remove);
        accessorySavedList.appendChild(row);
      });
      updateTotal();
    }

    function dispatchAccessoryEditorConfig(card, reset) {
      if (!accessoryEditorRoot || !card) return;
      try {
        accessoryEditorRoot.dispatchEvent(new CustomEvent('ll:image-editor:configure', {
          detail: {
            shape: card.getAttribute('data-ll-accessory-shape') || 'accessory-keychain-heart',
            mask: card.getAttribute('data-ll-accessory-mask') || '',
            reset: !!reset,
            message: 'Customize the selected accessory.'
          }
        }));
      } catch (e) {}
    }

    function syncAccessoryCustomizer(forceReset) {
      var card = getSelectedAccessoryCard();
      var isNone = !card || card.getAttribute('data-ll-accessory-card') === 'none';
      var nextKey = isNone ? '' : (card.getAttribute('data-ll-accessory-card') || '');
      var changed = nextKey !== activeAccessoryKey;

      if (changed || forceReset) {
        activeAccessoryKey = nextKey;
        accessorySaved = false;
        if (accessoryCustomizeLabel) accessoryCustomizeLabel.textContent = 'Customize Accessory';
      }

      if (isNone) {
        if (accessoryCustomizeButton) accessoryCustomizeButton.disabled = true;
        if (accessoryCustomizeStatus) {
          accessoryCustomizeStatus.textContent = accessoryItems.length
            ? 'Your saved accessories remain below. Select an accessory to add another.'
            : 'Select an accessory above to customize it.';
        }
        if (changed && accessoryEditorRoot) {
          var fallbackCard = accessoryBlock ? qs(accessoryBlock, '[data-ll-accessory-card]:not([data-ll-accessory-card="none"])') : null;
          if (fallbackCard) dispatchAccessoryEditorConfig(fallbackCard, true);
        }
        updateBaseNativeControls(accessoryBlock);
        return;
      }

      if (accessoryCustomizeButton) accessoryCustomizeButton.disabled = false;
      if (accessoryCustomizeStatus) {
        accessoryCustomizeStatus.textContent = 'Customize ' + (card.getAttribute('data-ll-accessory-title') || 'this accessory') + ' to add it to your saved accessories.';
      }
      if (changed || forceReset) dispatchAccessoryEditorConfig(card, true);
      updateBaseNativeControls(accessoryBlock);
    }

    if (accessoryCustomizeButton) {
      accessoryCustomizeButton.addEventListener('click', function () {
        var card = getSelectedAccessoryCard();
        if (!card || card.getAttribute('data-ll-accessory-card') === 'none' || !accessoryEditorRoot) return;
        var startFresh = accessorySaved;
        accessorySaved = false;
        dispatchAccessoryEditorConfig(card, startFresh);

        /* Stage 7W: real-phone accessory picker fix.
           Do not route the visible Customize Accessory tap through the hidden
           editor upload helper button. Mobile Safari/Chrome can reject that
           second synthetic click just like the main Personalize button did.
           Call the hidden accessory editor's real file input picker directly
           while we are still inside the customer's tap event. */
        if (typeof accessoryEditorRoot.__llRequestOriginalPhoto === 'function') {
          accessoryEditorRoot.__llRequestOriginalPhoto();
          return;
        }

        /* Defensive fallback for unusually slow script initialization. Keep this
           as a single direct activation of the actual file input; never click the
           hidden upload-trigger button here. */
        var originalInput = qs(accessoryEditorRoot, '[data-ll-editor-original-input]');
        if (originalInput) {
          try {
            if (typeof originalInput.showPicker === 'function') {
              originalInput.showPicker();
              return;
            }
          } catch (e) {}
          try { originalInput.click(); } catch (e) {}
        }
      });
    }

    if (accessoryEditorRoot) {
      accessoryEditorRoot.addEventListener('ll:image-editor:status', function (event) {
        var detail = event.detail || {};
        if (!detail.secondary) return;
        if (detail.status === 'saved') {
          var card = getSelectedAccessoryCard();
          if (!card || card.getAttribute('data-ll-accessory-card') === 'none') return;

          var variantId = parseInt(card.getAttribute('data-ll-accessory-variant-id') || '0', 10) || 0;
          var originalUrl = detail.cloudOriginalUrl || getAccessoryEditorValue('[data-ll-original-photo-url]', '');
          var previewUrl = detail.cloudPreviewUrl || detail.previewUrl || getAccessoryEditorValue('[data-ll-preview-photo-url]', '');
          var itemId = detail.customizationId || getAccessoryEditorValue('[data-ll-customization-id]', '') || ('accessory-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8));

          if (!variantId || !originalUrl || !previewUrl) {
            accessorySaved = false;
            if (accessoryCustomizeStatus) accessoryCustomizeStatus.textContent = 'The accessory could not be saved. Please try again.';
            return;
          }

          accessoryItems.push({
            id: itemId,
            name: card.getAttribute('data-ll-accessory-title') || 'Crystal Accessory',
            handle: card.getAttribute('data-ll-accessory-handle') || '',
            shape: card.getAttribute('data-ll-accessory-shape') || '',
            variantId: variantId,
            price: parseInt(card.getAttribute('data-ll-accessory-price') || '0', 10) || 0,
            size: card.getAttribute('data-ll-accessory-size') || '',
            customizationId: itemId,
            originalUrl: originalUrl,
            previewUrl: previewUrl,
            cropData: getAccessoryEditorValue('[data-ll-crop-data-input]', ''),
            rotation: getAccessoryEditorValue('[data-ll-rotation-input]', '0'),
            zoom: getAccessoryEditorValue('[data-ll-zoom-input]', '100')
          });

          accessorySaved = true;
          if (accessoryCustomizeLabel) accessoryCustomizeLabel.textContent = 'Customize Another';
          if (accessoryCustomizeStatus) accessoryCustomizeStatus.textContent = 'Accessory added. Keep it below, select a different accessory, or customize another one.';
          renderAccessoryItems();
        } else if (detail.status === 'editing') {
          if (accessoryCustomizeLabel) accessoryCustomizeLabel.textContent = 'Finish Accessory Customization';
          if (accessoryCustomizeStatus) accessoryCustomizeStatus.textContent = 'Editing accessory — save the photo when finished.';
        } else if (detail.status === 'error') {
          accessorySaved = false;
          if (accessoryCustomizeStatus) accessoryCustomizeStatus.textContent = detail.text || 'Please finish customizing the accessory.';
        }
      });
    }

    function syncOptionSelectedStates() {
      qsa(root, '[data-ll-addon-radio]').forEach(function (radio) {
        var card = radio.closest('.ll-cfg-addon-card');
        if (card) card.classList.toggle('is-selected', radio.checked);
      });
      if (removeLightBaseButton && lightBaseNoneInput) {
        removeLightBaseButton.classList.toggle('is-selected', !!lightBaseNoneInput.checked);
        removeLightBaseButton.setAttribute('aria-pressed', lightBaseNoneInput.checked ? 'true' : 'false');
      }
      qsa(root, '[data-ll-addon]').forEach(function (checkbox) {
        var option = checkbox.closest('.ll-cfg-option');
        var wrap = checkbox.closest('.ll-cfg-option-wrap');
        if (option) option.classList.toggle('is-selected', checkbox.checked);
        if (wrap) wrap.classList.toggle('is-selected', checkbox.checked);
      });
    }

    if (removeLightBaseButton && lightBaseNoneInput) {
      removeLightBaseButton.addEventListener('click', function () {
        if (lightBaseNoneInput.disabled) return;
        lightBaseNoneInput.checked = true;
        try { lightBaseNoneInput.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
      });
    }

    qsa(root, '[data-ll-addon], [data-ll-addon-radio]').forEach(function (input) {
      input.addEventListener('change', function () {
        syncOptionSelectedStates();
        updateTotal();
        updateBaseNativeControls(lightBaseBlock);
        updateBaseNativeControls(accessoryBlock);
        if (input.closest('[data-ll-accessory-upsell]')) syncAccessoryCustomizer(false);
      });
    });
    syncOptionSelectedStates();
    syncTextCalibrationPanel(root);

    document.addEventListener('ll:text-calibration-toggle', function (event) {
      var enabled = !!(event && event.detail && event.detail.enabled);
      if (enabled) {
        syncTextCalibrationPanel(root);
        updateMainEngravingPreview(root);
      } else {
        var panel = qs(root, '[data-ll-text-calibration-panel]');
        if (panel && panel.parentNode) panel.parentNode.removeChild(panel);
        root.__llTextCalibration = null;
        updateMainEngravingPreview(root);
      }
    });

    qsa(root, '[data-ll-engraving-wrap]').forEach(function (wrap) {
      var toggle = qs(wrap, '[data-ll-engraving-toggle]');
      var field = qs(wrap, '[data-ll-engraving-field]');
      var hiddenInput = qs(wrap, '[data-ll-engraving-input]');
      var line1Input = qs(wrap, '[data-ll-engraving-line1]');
      var line2Input = qs(wrap, '[data-ll-engraving-line2]');
      function updateEngravingField() {
        var enabled = !!(toggle && toggle.checked);
        if (field) field.hidden = !enabled;
        [hiddenInput, line1Input, line2Input].forEach(function (input) {
          if (!input) return;
          input.disabled = !enabled;
          if (!enabled) input.value = '';
        });
        syncEngravingHiddenInput(root);
        updateMainEngravingPreview(root);
      }
      if (toggle) toggle.addEventListener('change', updateEngravingField);
      [line1Input, line2Input].forEach(function (input) {
        if (!input) return;
        input.addEventListener('input', function () {
          syncEngravingHiddenInput(root);
          updateMainEngravingPreview(root);
        });
      });
      updateEngravingField();
    });

    /* Stage 7V: open the real file input directly from the customer's click.
       Avoid visible button -> hidden helper button -> file input chaining, which
       can be blocked by real mobile browsers even though desktop/emulation works. */
    function openMainPhotoEditorFromGesture() {
      if (mainEditorRoot && typeof mainEditorRoot.__llOpenOrEditPhoto === 'function') {
        return mainEditorRoot.__llOpenOrEditPhoto();
      }

      /* Backward-compatible fallback if the editor has not exposed its direct API. */
      var editAgainTrigger = qs(root, '[data-ll-editor-edit-again]');
      var uploadTrigger = qs(root, '[data-ll-editor-upload-trigger]');
      if (editAgainTrigger && !editAgainTrigger.hidden) {
        editAgainTrigger.click();
        return true;
      }
      if (uploadTrigger) {
        uploadTrigger.click();
        return true;
      }
      return false;
    }

    qsa(root, '[data-ll-personalize-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        if (event) event.preventDefault();
        openMainPhotoEditorFromGesture();
      });
    });

    if (editPhotoAgain) {
      editPhotoAgain.addEventListener('click', function (event) {
        if (event) event.preventDefault();
        openMainPhotoEditorFromGesture();
      });
    }

    root.addEventListener('ll:image-editor:status', function (event) {
      var detail = event.detail || {};
      if (detail.secondary) return;
      if (!photoStatus || !photoStatusText) return;
      photoStatus.classList.remove('is-ready', 'is-error', 'is-editing');
      if (detail.status === 'saved') {
        setPhotoFlowReady(true);
        setTimeout(function () {
          updateBaseNativeControls(lightBaseBlock);
          updateBaseNativeControls(accessoryBlock);
        }, 40);
        photoStatus.hidden = true;
        photoStatus.classList.add('is-ready');
        photoStatusText.textContent = '';
        if (personalizeLabel) personalizeLabel.textContent = 'Edit Photo';
        if (editPhotoAgain) editPhotoAgain.hidden = false;
        setTimeout(function () { syncTextCalibrationPanel(root); updateMainEngravingPreview(root); }, 80);
      } else if (detail.status === 'error') {
        photoStatus.hidden = false;
        photoStatus.classList.add('is-error');
        photoStatusText.textContent = detail.text || 'Please personalize your crystal before adding to cart.';
      } else if (detail.status === 'editing') {
        if (!photoFlowReady) setPhotoFlowReady(false);
        photoStatus.hidden = false;
        photoStatus.classList.add('is-editing');
        photoStatusText.textContent = 'Editing in progress — save the crop before adding to cart.';
        if (personalizeLabel) personalizeLabel.textContent = 'Finish Personalization';
        if (editPhotoAgain) editPhotoAgain.hidden = true;
        updateMainEngravingPreview(root);
      } else {
        photoStatus.hidden = false;
        photoStatusText.textContent = detail.text || 'Upload your photo to start the personalization.';
      }
    });

    function restorePhotoAfterShapeNavigation() {
      var pending = readPendingShapePhotoTransfer();
      if (!pending) return;

      var age = Date.now() - (parseInt(pending.createdAt || 0, 10) || 0);
      if (age > LL_SHAPE_PHOTO_TRANSFER_MAX_AGE) {
        clearPendingShapePhotoTransfer();
        return;
      }

      var currentShape = getCurrentShapeKey(root);
      if (!pending.targetShape || pending.targetShape !== currentShape) return;
      if (!mainEditorRoot || typeof mainEditorRoot.__llRestoreMainPhotoTransfer !== 'function') return;

      clearPendingShapePhotoTransfer();
      mainEditorRoot.__llRestoreMainPhotoTransfer(pending.photo || null).catch(function (err) {
        console.warn('[LL configurator] The previous photo could not be restored:', err);
        if (photoStatus && photoStatusText) {
          photoStatus.hidden = false;
          photoStatus.classList.remove('is-ready', 'is-editing');
          photoStatus.classList.add('is-error');
          photoStatusText.textContent = 'The previous photo could not be carried over. Please upload it again.';
        }
      });
    }

    var selected = qs(root, '.ll-cfg-size.is-selected') || qs(root, '.ll-cfg-size');
    if (selected) selectVariant(selected);
    renderAccessoryItems();
    syncAccessoryCustomizer(false);
    updateTotal();
    updateMainEngravingPreview(root);
    setTimeout(restorePhotoAfterShapeNavigation, 80);
    document.addEventListener('ll:image-editor:preview-saved', function () {
      setTimeout(function () { updateMainEngravingPreview(root); }, 80);
    });
    window.addEventListener('resize', function () { updateMainEngravingPreview(root); });
  }


  function initAccessoryConfigurator(root) {
    if (!root || root.getAttribute('data-ll-accessory-ready')) return;
    root.setAttribute('data-ll-accessory-ready', 'true');

    var form = root.closest('form');
    var panel = root.closest('.ll-configurator-panel');
    var page = root.closest('.ll-product-configurator-page');
    var photoStatus = qs(root, '[data-ll-photo-status]');
    var photoStatusText = qs(root, '[data-ll-photo-status-text]');
    var personalizeLabel = qs(root, '[data-ll-personalize-label]');
    var editPhotoAgain = qs(root, '[data-ll-edit-photo-again]');
    var qtyCart = form ? qs(form, '.qty-cart') : null;
    var select = form ? qs(form, '#productSelect') : null;
    var priceNode = document.querySelector('.enj-product-price');
    var compareNode = document.querySelector('.enj-product-price-compare');
    var editorRoot = qs(root, '[data-ll-image-editor]');
    var shapeInput = qs(root, '[data-ll-accessory-shape-input]');
    var sizeInput = qs(root, '[data-ll-accessory-size-input]');

    function openAccessoryEditor() {
      var editAgainTrigger = qs(root, '[data-ll-editor-edit-again]');
      var uploadTrigger = qs(root, '[data-ll-editor-upload-trigger]');
      if (editAgainTrigger && !editAgainTrigger.hidden) editAgainTrigger.click();
      else if (uploadTrigger) uploadTrigger.click();
    }

    function setAccessoryReady(ready) {
      root.classList.toggle('ll-accessory-photo-ready', !!ready);
      root.classList.toggle('ll-accessory-awaiting-photo', !ready);
      root.classList.toggle('ll-cfg-photo-ready', !!ready);
      root.classList.toggle('ll-cfg-awaiting-photo', !ready);

      if (panel) {
        panel.classList.toggle('ll-accessory-photo-ready', !!ready);
        panel.classList.toggle('ll-accessory-awaiting-photo', !ready);
      }

      if (page) {
        page.classList.toggle('ll-accessory-photo-ready', !!ready);
        page.classList.toggle('ll-accessory-awaiting-photo', !ready);
      }
    }

    function selectAccessoryVariant(button) {
      if (!button || button.disabled) return;
      var variantId = button.getAttribute('data-ll-variant-id') || '';
      var price = parseInt(button.getAttribute('data-ll-variant-price') || '0', 10) || 0;
      var compare = parseInt(button.getAttribute('data-ll-variant-compare') || '0', 10) || 0;
      var sizeLabel = button.getAttribute('data-ll-size-label') || button.textContent.trim();

      qsa(root, '[data-ll-accessory-size-choice]').forEach(function (candidate) {
        var selected = candidate === button;
        candidate.classList.toggle('is-selected', selected);
        candidate.setAttribute('aria-checked', selected ? 'true' : 'false');
      });

      if (select && variantId) {
        select.value = variantId;
        try { select.dispatchEvent(new Event('change', { bubbles: true })); }
        catch (e) { if (window.jQuery) jQuery(select).trigger('change'); }
      }

      if (sizeInput) sizeInput.value = sizeLabel;
      if (priceNode) priceNode.textContent = centsToMoney(price);
      if (qtyCart) qtyCart.setAttribute('data-ll-total-label', centsToMoney(price));
      if (compareNode) {
        compareNode.textContent = compare > price ? centsToMoney(compare) : '';
        compareNode.style.display = compare > price ? '' : 'none';
      }
    }

    function getSelectedAccessorySize() {
      var selected = qs(root, '[data-ll-accessory-size-choice].is-selected');
      return selected ? (selected.getAttribute('data-ll-size-label') || '') : '';
    }

    function accessoryTargetUrl(rawUrl) {
      var built = buildPreviewSafeUrl(rawUrl);
      try {
        var target = new URL(built, window.location.origin);
        var selectedSize = getSelectedAccessorySize();
        if (selectedSize) target.searchParams.set('ll_accessory_size', selectedSize);
        return target.toString();
      } catch (e) {
        return built;
      }
    }

    function restoreAccessoryPhotoAfterShapeNavigation() {
      var pending = readPendingShapePhotoTransfer();
      if (!pending) return;

      var age = Date.now() - (parseInt(pending.createdAt || 0, 10) || 0);
      if (age > LL_SHAPE_PHOTO_TRANSFER_MAX_AGE) {
        clearPendingShapePhotoTransfer();
        return;
      }

      var currentShape = root.getAttribute('data-ll-current-shape-key') || '';
      if (!pending.targetShape || pending.targetShape !== currentShape) return;
      if (!editorRoot || typeof editorRoot.__llRestoreMainPhotoTransfer !== 'function') return;

      clearPendingShapePhotoTransfer();
      editorRoot.__llRestoreMainPhotoTransfer(pending.photo || null).catch(function (err) {
        console.warn('[LL accessory configurator] The previous photo could not be restored:', err);
        if (photoStatus && photoStatusText) {
          photoStatus.hidden = false;
          photoStatus.classList.remove('is-ready', 'is-editing');
          photoStatus.classList.add('is-error');
          photoStatusText.textContent = 'The previous photo could not be carried over. Please upload it again.';
        }
      });
    }

    qsa(root, '[data-ll-accessory-size-choice]').forEach(function (button) {
      button.addEventListener('click', function () { selectAccessoryVariant(button); });
    });

    var requestedSize = '';
    try { requestedSize = new URL(window.location.href).searchParams.get('ll_accessory_size') || ''; }
    catch (e) {}

    var initialSizeButton = null;
    if (requestedSize) {
      qsa(root, '[data-ll-accessory-size-choice]').some(function (button) {
        var label = (button.getAttribute('data-ll-size-label') || '').trim().toLowerCase();
        if (label === requestedSize.trim().toLowerCase() && !button.disabled) {
          initialSizeButton = button;
          return true;
        }
        return false;
      });
    }
    if (!initialSizeButton) initialSizeButton = qs(root, '[data-ll-accessory-size-choice].is-selected:not(.is-disabled)');
    if (!initialSizeButton) initialSizeButton = qs(root, '[data-ll-accessory-size-choice]:not(.is-disabled)');
    if (initialSizeButton) selectAccessoryVariant(initialSizeButton);
    else if (qtyCart && priceNode && priceNode.textContent) qtyCart.setAttribute('data-ll-total-label', priceNode.textContent.trim());

    qsa(root, '[data-ll-accessory-shape-choice]').forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        if (button.classList.contains('is-selected')) return;

        var shapeLabel = button.getAttribute('data-ll-accessory-shape-choice') || '';
        var shapeKey = button.getAttribute('data-ll-shape-key') || '';
        var rawUrl = button.getAttribute('data-ll-fallback-url') || '';
        if (!rawUrl || rawUrl === '#') return;
        if (shapeInput) shapeInput.value = shapeLabel;

        function navigate() {
          window.location.assign(accessoryTargetUrl(rawUrl));
        }

        var hasPhoto = !!(editorRoot && typeof editorRoot.__llHasTransferableMainPhoto === 'function' && editorRoot.__llHasTransferableMainPhoto());
        if (!hasPhoto || typeof editorRoot.__llPrepareMainPhotoTransfer !== 'function') {
          navigate();
          return;
        }

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        editorRoot.__llPrepareMainPhotoTransfer().then(function (photoMetadata) {
          savePendingShapePhotoTransfer(shapeKey, photoMetadata);
        }).catch(function (err) {
          console.warn('[LL accessory configurator] The photo could not be prepared for shape transfer:', err);
        }).then(navigate);
      });
    });

    qsa(root, '[data-ll-personalize-trigger]').forEach(function (btn) {
      btn.addEventListener('click', openAccessoryEditor);
    });

    if (editPhotoAgain) editPhotoAgain.addEventListener('click', openAccessoryEditor);

    setAccessoryReady(false);
    if (photoStatus && photoStatusText) {
      photoStatus.hidden = false;
      photoStatus.classList.remove('is-ready', 'is-error', 'is-editing');
      photoStatusText.textContent = 'Upload your photo to start the personalization.';
    }

    root.addEventListener('ll:image-editor:status', function (event) {
      var detail = event.detail || {};
      if (!photoStatus || !photoStatusText) return;

      photoStatus.classList.remove('is-ready', 'is-error', 'is-editing');

      if (detail.status === 'saved') {
        setAccessoryReady(true);
        photoStatus.hidden = true;
        photoStatus.classList.add('is-ready');
        photoStatusText.textContent = '';
        if (personalizeLabel) personalizeLabel.textContent = 'Edit Photo';
        if (editPhotoAgain) editPhotoAgain.hidden = false;
      } else if (detail.status === 'error') {
        setAccessoryReady(false);
        photoStatus.hidden = false;
        photoStatus.classList.add('is-error');
        photoStatusText.textContent = detail.text || 'Please personalize this product before adding to cart.';
        if (personalizeLabel) personalizeLabel.textContent = 'Personalize Your Product';
        if (editPhotoAgain) editPhotoAgain.hidden = true;
      } else if (detail.status === 'editing') {
        photoStatus.hidden = false;
        photoStatus.classList.add('is-editing');
        photoStatusText.textContent = 'Editing in progress — save the crop before adding to cart.';
        if (personalizeLabel) personalizeLabel.textContent = 'Finish Personalization';
        if (editPhotoAgain) editPhotoAgain.hidden = true;
      } else {
        setAccessoryReady(false);
        photoStatus.hidden = false;
        photoStatusText.textContent = detail.text || 'Upload your photo to start the personalization.';
      }
    });

    setTimeout(restoreAccessoryPhotoAfterShapeNavigation, 100);
  }


  function initLightBaseInfoModal(root) {
    if (!root || root.__llLightBaseInfoReady) return;
    var openButton = qs(root, '[data-ll-lightbase-info-open]');
    var modal = qs(root, '[data-ll-lightbase-info-modal]');
    if (!openButton || !modal) return;

    root.__llLightBaseInfoReady = true;
    var closeButtons = qsa(modal, '[data-ll-lightbase-info-close]');
    var closeButton = qs(modal, '.ll-lightbase-info-modal__close');
    var previousFocus = null;

    function openModal() {
      previousFocus = document.activeElement;
      modal.hidden = false;
      modal.classList.add('is-open');
      document.documentElement.classList.add('ll-lightbase-modal-open');
      document.body.classList.add('ll-lightbase-modal-open');
      openButton.setAttribute('aria-expanded', 'true');
      window.requestAnimationFrame(function () {
        if (closeButton) closeButton.focus();
      });
    }

    function closeModal() {
      if (modal.hidden) return;
      modal.classList.remove('is-open');
      modal.hidden = true;
      document.documentElement.classList.remove('ll-lightbase-modal-open');
      document.body.classList.remove('ll-lightbase-modal-open');
      openButton.setAttribute('aria-expanded', 'false');
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
    }

    openButton.setAttribute('aria-expanded', 'false');
    openButton.addEventListener('click', function (event) {
      event.preventDefault();
      openModal();
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        closeModal();
      });
    });

    document.addEventListener('keydown', function (event) {
      if (modal.hidden) return;
      if (event.key === 'Escape' || event.keyCode === 27) {
        event.preventDefault();
        closeModal();
      }
    });
  }

  function initAll() {
    qsa(document, '[data-ll-configurator]').forEach(function (root) {
      initConfigurator(root);
      initLightBaseInfoModal(root);
    });
    qsa(document, '[data-ll-accessory-configurator]').forEach(initAccessoryConfigurator);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();

/* Stage 3D: stabilize gallery thumbnails after legacy carousel scripts run. */
(function () {
  'use strict';

  function normalizeSrc(src) {
    return String(src || '').split('?')[0].replace(/_(pico|icon|thumb|small|compact|medium|large|grande|master)(?=\.)/i, '');
  }

  function cleanGallery(gallery) {
    if (!gallery || gallery.__llGalleryCleaned) return;
    var list = gallery.querySelector('[data-ll-gallery-thumbs], .gallery-control .carousel ul');
    if (!list) return;
    var seen = Object.create(null);
    Array.prototype.slice.call(list.querySelectorAll('li')).forEach(function (li) {
      var img = li.querySelector('img');
      var key = img ? normalizeSrc(img.getAttribute('src') || img.src) : '';
      if (!key || seen[key]) {
        li.parentNode && li.parentNode.removeChild(li);
        return;
      }
      seen[key] = true;
      li.style.position = 'static';
      li.style.left = '';
      li.style.top = '';
      li.style.float = 'none';
    });
    list.style.position = 'static';
    list.style.left = 'auto';
    list.style.transform = 'none';
    list.style.width = 'auto';
    gallery.__llGalleryCleaned = true;
  }

  function initStableGalleries() {
    Array.prototype.slice.call(document.querySelectorAll('.ll-configurator-media .detail-gallery')).forEach(function (gallery) {
      cleanGallery(gallery);
      setTimeout(function () { gallery.__llGalleryCleaned = false; cleanGallery(gallery); }, 400);
      setTimeout(function () { gallery.__llGalleryCleaned = false; cleanGallery(gallery); }, 1200);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initStableGalleries);
  else initStableGalleries();
})();

/* Stage 3M: CSS-sticky preview sizing only.
   The earlier fixed/absolute sticky fallback caused horizontal snaps at the
   bottom boundary. This version does not move the gallery with JS. It only
   gives the left media column the same height as the configurator column, so
   native CSS sticky can keep the preview aligned and stop naturally. */
(function () {
  'use strict';

  var MQ = '(min-width: 992px)';
  var raf = null;

  function qsa(root, selector) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function clearLegacySticky(gallery) {
    if (!gallery) return;
    gallery.classList.remove('ll-preview-is-fixed', 'll-preview-is-bottom');
    ['position', 'top', 'left', 'right', 'bottom', 'width', 'height', 'min-width', 'max-width', 'z-index'].forEach(function (prop) {
      gallery.style.removeProperty(prop);
    });
  }

  function topOffset() {
    var offset = 24;
    qsa(document, 'header, .site-header, .header, .menu-fixed, .sticky, .navbar-fixed-top').forEach(function (el) {
      var cs = window.getComputedStyle(el);
      if ((cs.position === 'fixed' || cs.position === 'sticky') && el.offsetHeight) {
        var rect = el.getBoundingClientRect();
        if (rect.top <= 2 && rect.bottom > 0) offset = Math.max(offset, Math.ceil(rect.bottom + 18));
      }
    });
    return Math.min(offset, 120);
  }

  function updateStickySizing() {
    raf = null;
    var desktop = window.matchMedia(MQ).matches;

    qsa(document, '.ll-product-configurator-page .ll-configurator-media').forEach(function (media) {
      var row = media.closest('.product-detail > .row') || media.closest('.row') || media.parentNode;
      var panel = row ? row.querySelector('.ll-configurator-panel-col') : null;
      var gallery = media.querySelector('.detail-gallery');
      if (!gallery) return;

      clearLegacySticky(gallery);

      if (!desktop || !panel) {
        media.classList.remove('ll-preview-sticky-managed');
        media.style.removeProperty('height');
        media.style.removeProperty('min-height');
        media.style.removeProperty('--ll-sticky-top');
        media.style.removeProperty('--ll-preview-column-height');
        media.style.removeProperty('--ll-preview-width');
        return;
      }

      var galleryRect = gallery.getBoundingClientRect();
      var panelHeight = Math.max(panel.offsetHeight, panel.scrollHeight, panel.getBoundingClientRect().height || 0);
      var galleryHeight = Math.max(gallery.offsetHeight, gallery.scrollHeight, galleryRect.height || 0);
      var columnHeight = Math.max(panelHeight, galleryHeight);

      media.classList.add('ll-preview-sticky-managed');
      media.style.setProperty('--ll-sticky-top', topOffset() + 'px');
      media.style.setProperty('--ll-preview-column-height', Math.ceil(columnHeight) + 'px');
      media.style.height = Math.ceil(columnHeight) + 'px';
      media.style.minHeight = Math.ceil(galleryHeight) + 'px';
    });
  }

  function scheduleUpdate() {
    if (raf) return;
    raf = window.requestAnimationFrame(updateStickySizing);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleUpdate);
  else scheduleUpdate();

  window.addEventListener('load', function () {
    scheduleUpdate();
    setTimeout(scheduleUpdate, 300);
    setTimeout(scheduleUpdate, 900);
  });
  window.addEventListener('resize', scheduleUpdate);

  document.addEventListener('change', scheduleUpdate, true);
  document.addEventListener('click', function () {
    setTimeout(scheduleUpdate, 80);
    setTimeout(scheduleUpdate, 320);
  }, true);
})();

/* Stage 3N: no-jump transform sticky preview.
   We no longer switch the gallery between normal/fixed/absolute positions.
   Instead, the gallery stays in the left column and translates down until the
   right configurator ends. This preserves its width and horizontal alignment. */
(function () {
  'use strict';

  var MQ = '(min-width: 992px)';
  var raf = null;

  function qsa(root, selector) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function docTop(el) {
    return el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0);
  }

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function topOffset() {
    var offset = 24;
    qsa(document, 'header, .site-header, .header, .menu-fixed, .navbar-fixed-top').forEach(function (el) {
      var cs = window.getComputedStyle(el);
      if ((cs.position === 'fixed' || cs.position === 'sticky') && el.offsetHeight) {
        var rect = el.getBoundingClientRect();
        if (rect.top <= 2 && rect.bottom > 0) offset = Math.max(offset, Math.ceil(rect.bottom + 18));
      }
    });
    return Math.min(offset, 120);
  }

  function reset(media, gallery) {
    media.classList.remove('ll-preview-translate-managed', 'll-preview-sticky-managed');
    var stack = media ? media.querySelector('.ll-configurator-media-stack') : null;
    if (stack) stack.style.removeProperty('transform');
    media.style.removeProperty('--ll-preview-y');
    media.style.removeProperty('--ll-preview-column-height');
    media.style.removeProperty('height');
    media.style.removeProperty('min-height');
    if (gallery) {
      gallery.classList.remove('ll-preview-is-fixed', 'll-preview-is-bottom');
      gallery.style.removeProperty('position');
      gallery.style.removeProperty('top');
      gallery.style.removeProperty('left');
      gallery.style.removeProperty('right');
      gallery.style.removeProperty('bottom');
      gallery.style.removeProperty('width');
      gallery.style.removeProperty('min-width');
      gallery.style.removeProperty('max-width');
      gallery.style.removeProperty('transform');
    }
  }

  function update() {
    raf = null;
    var desktop = window.matchMedia(MQ).matches;
    var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var stickyTop = topOffset();

    qsa(document, '.ll-product-configurator-page .ll-configurator-media').forEach(function (media) {
      var row = media.closest('.product-detail > .row') || media.closest('.row') || media.parentNode;
      var panel = row ? row.querySelector('.ll-configurator-panel-col') : null;
      var gallery = media.querySelector('.detail-gallery');
      if (!gallery) return;

      if (!desktop || !panel) {
        reset(media, gallery);
        return;
      }

      // Remove old fixed/bottom classes but keep our transform-controlled state.
      gallery.classList.remove('ll-preview-is-fixed', 'll-preview-is-bottom');

      var panelHeight = Math.max(panel.offsetHeight, panel.scrollHeight, Math.ceil(panel.getBoundingClientRect().height || 0));
      var galleryHeight = Math.max(gallery.offsetHeight, gallery.scrollHeight, Math.ceil(gallery.getBoundingClientRect().height || 0));
      var mediaTop = docTop(media);

      // Product Info is visually attached below the preview, but it must not shorten
      // the preview's original travel distance. Stop based on the preview height only.
      var maxY = Math.max(0, panelHeight - galleryHeight);
      var nextY = clamp(scrollY + stickyTop - mediaTop, 0, maxY);

      media.classList.add('ll-preview-translate-managed');
      media.classList.remove('ll-preview-sticky-managed');
      // Keep Product Info and the whole page height in normal document flow.
      // Only translate the gallery. Never rewrite the media column height while
      // upload/editor/configurator state changes, because doing so can briefly
      // collapse/expand the row and make the footer flash into view.
      media.style.removeProperty('--ll-preview-column-height');
      media.style.removeProperty('height');
      media.style.removeProperty('min-height');
      media.style.setProperty('--ll-preview-y', Math.round(nextY) + 'px');
    });
  }

  function schedule() {
    if (raf) return;
    raf = window.requestAnimationFrame(update);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();

  window.addEventListener('load', function () {
    schedule();
    setTimeout(schedule, 250);
    setTimeout(schedule, 900);
  });
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);
  document.addEventListener('change', function () { setTimeout(schedule, 50); setTimeout(schedule, 300); }, true);
  document.addEventListener('click', function () { setTimeout(schedule, 50); setTimeout(schedule, 300); }, true);
})();


/* Stage 7P: reliable mobile sticky preview mirror.
   A fixed mirror avoids the legacy layout/iframe conditions that prevent
   position:sticky from behaving consistently on mobile. */
(function () {
  'use strict';

  var MQ = '(max-width: 767px)';
  var sticky = null;
  var raf = null;
  var lastSignature = '';

  function qs(root, selector) {
    return (root || document).querySelector(selector);
  }

  function ensureSticky() {
    if (sticky && document.body.contains(sticky)) return sticky;
    sticky = document.createElement('div');
    sticky.className = 'll-mobile-sticky-preview';
    sticky.setAttribute('aria-hidden', 'true');
    document.body.appendChild(sticky);
    return sticky;
  }

  function fixedHeaderOffset() {
    var offset = 6;
    var selectors = ['header', '.site-header', '.header', '.menu-fixed', '.navbar-fixed-top'];
    selectors.forEach(function (selector) {
      Array.prototype.slice.call(document.querySelectorAll(selector)).forEach(function (el) {
        if (!el || el === sticky || !el.offsetHeight) return;
        var cs = window.getComputedStyle(el);
        if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
        var rect = el.getBoundingClientRect();
        if (rect.top <= 2 && rect.bottom > 0 && rect.bottom < 140) {
          offset = Math.max(offset, Math.ceil(rect.bottom + 6));
        }
      });
    });
    return Math.min(offset, 120);
  }

  function signature(mid) {
    if (!mid) return '';
    var img = qs(mid, 'img.engoj_img_main');
    var engraving = qs(mid, '[data-ll-main-engraving-preview-text]');
    return [
      img ? (img.currentSrc || img.src || '') : '',
      engraving ? engraving.textContent : '',
      engraving && engraving.parentNode ? engraving.parentNode.getAttribute('style') || '' : ''
    ].join('|');
  }

  function syncMirror(mid, force) {
    if (!mid) return;
    var nextSignature = signature(mid);
    if (!force && nextSignature === lastSignature && sticky && sticky.firstChild) return;
    lastSignature = nextSignature;
    var box = ensureSticky();
    while (box.firstChild) box.removeChild(box.firstChild);
    var clone = mid.cloneNode(true);
    /* A cloned Cropper canvas is not needed here; after Save photo the normal
       product preview is an image plus optional engraving overlay. */
    Array.prototype.slice.call(clone.querySelectorAll('canvas, .cropper-container')).forEach(function (node) {
      if (node.parentNode) node.parentNode.removeChild(node);
    });
    box.appendChild(clone);
  }

  function hide() {
    if (sticky) sticky.classList.remove('is-visible');
  }

  function update() {
    raf = null;
    if (!window.matchMedia(MQ).matches) {
      hide();
      return;
    }

    var page = qs(document, '.ll-product-configurator-page');
    if (!page) {
      hide();
      return;
    }

    var media = qs(page, '.ll-configurator-media');
    var panel = qs(page, '.ll-configurator-panel-col');
    var gallery = media ? qs(media, '.detail-gallery') : null;
    var mid = gallery ? qs(gallery, '.mid') : null;

    /* Only mirror an actual saved customer preview. */
    if (!media || !panel || !gallery || !mid || !gallery.classList.contains('ll-preview-locked')) {
      hide();
      return;
    }

    syncMirror(mid, false);

    var box = ensureSticky();
    var top = fixedHeaderOffset();
    box.style.setProperty('--ll-mobile-sticky-top', top + 'px');

    var mediaRect = media.getBoundingClientRect();
    var panelRect = panel.getBoundingClientRect();
    var stickyHeight = box.offsetHeight || 188;

    /* Show after the normal preview has left the viewport, keep it while the
       options panel is being browsed, then release it before the panel ends. */
    var originalHasPassed = mediaRect.bottom <= top + 2;
    var optionsStillVisible = panelRect.bottom > top + stickyHeight + 14;

    box.classList.toggle('is-visible', originalHasPassed && optionsStillVisible);
  }

  function schedule(forceSync) {
    if (forceSync) {
      lastSignature = '';
      var page = qs(document, '.ll-product-configurator-page');
      var mid = page ? qs(page, '.ll-configurator-media .detail-gallery .mid') : null;
      if (mid) syncMirror(mid, true);
    }
    if (raf) return;
    raf = window.requestAnimationFrame(update);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { schedule(true); });
  } else {
    schedule(true);
  }

  window.addEventListener('load', function () { schedule(true); });
  window.addEventListener('scroll', function () { schedule(false); }, { passive: true });
  window.addEventListener('resize', function () { schedule(true); });

  document.addEventListener('ll:image-editor:preview-saved', function () {
    setTimeout(function () { schedule(true); }, 40);
    setTimeout(function () { schedule(true); }, 220);
  });
  document.addEventListener('input', function (event) {
    if (event.target && (event.target.matches('[data-ll-engraving-input]') || event.target.closest('.ll-cfg-engraving-field'))) {
      setTimeout(function () { schedule(true); }, 20);
    }
  }, true);
  document.addEventListener('change', function () { setTimeout(function () { schedule(true); }, 60); }, true);
  document.addEventListener('click', function () { setTimeout(function () { schedule(true); }, 100); }, true);
})();

/* Stage 7T: safe mobile-only suppression for WhatsApp/chat launchers and back-to-top.
   IMPORTANT: only known WhatsApp selectors and small corner IFRAMES are touched.
   Do not scan or rewrite generic fixed DIV/BUTTON elements; that can interfere with
   the configurator and mobile file-picker interaction on real phones. */
(function () {
  'use strict';

  var MQ = '(max-width: 767px)';
  var SELECTORS = [
    '.scroll-top',
    'a[href*="wa.me" i]',
    'a[href*="api.whatsapp.com" i]',
    'a[href*="whatsapp.com" i]',
    '[class*="whatsapp" i]',
    '[id*="whatsapp" i]',
    '[aria-label*="whatsapp" i]',
    '[title*="whatsapp" i]',
    '.whatsapp_float',
    '.ht-ctc-chat', '#ht-ctc-chat',
    '.joinchat', '#joinchat',
    '.chaty-widget', '[class*="chaty" i]', '[id*="chaty" i]'
  ];

  function onTargetPage() {
    if (!window.matchMedia(MQ).matches || !document.body) return false;
    return document.body.classList.contains('product') || !!document.querySelector('[data-ll-configurator]');
  }

  function hide(el) {
    if (!el || !el.style) return;
    /* Never touch the configurator/editor itself. */
    try {
      if (el.matches('[data-ll-configurator], .ll-image-editor-modal, .ll-cfg-mobile-cart, .ll-cfg-mobile-sticky-preview') ||
          el.closest('[data-ll-configurator], .ll-image-editor-modal, .ll-cfg-mobile-cart, .ll-cfg-mobile-sticky-preview')) return;
    } catch (e) {}
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('pointer-events', 'none', 'important');
    el.setAttribute('aria-hidden', 'true');
  }

  function hideKnown(scope) {
    if (!onTargetPage()) return;
    var root = scope && scope.querySelectorAll ? scope : document;
    SELECTORS.forEach(function (selector) {
      try {
        if (root.nodeType === 1 && root.matches && root.matches(selector)) hide(root);
        Array.prototype.slice.call(root.querySelectorAll(selector)).forEach(hide);
      } catch (e) {}
    });
  }

  function maybeHideCornerIframe(frame) {
    if (!onTargetPage() || !frame || frame.tagName !== 'IFRAME') return;
    var idText = [frame.id || '', frame.className || '', frame.getAttribute('src') || '', frame.getAttribute('title') || '', frame.getAttribute('name') || '', frame.getAttribute('aria-label') || ''].join(' ').toLowerCase();
    if (/(whatsapp|wa\.me|joinchat|chaty|ht-ctc)/.test(idText)) { hide(frame); return; }

    var cs, rect;
    try { cs = getComputedStyle(frame); rect = frame.getBoundingClientRect(); } catch (e) { return; }
    if (!cs || cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden') return;
    if (rect.width < 28 || rect.height < 28 || rect.width > 150 || rect.height > 150) return;
    var nearBottom = rect.bottom >= window.innerHeight - 180;
    var nearRight = rect.right >= window.innerWidth - 110;
    var nearLeft = rect.left <= 110;
    if (nearBottom && (nearRight || nearLeft)) hide(frame);
  }

  function inspectIframes(scope) {
    if (!onTargetPage()) return;
    var frames=[];
    if (scope && scope.nodeType === 1 && scope.tagName === 'IFRAME') frames.push(scope);
    try {
      var root = scope && scope.querySelectorAll ? scope : document;
      frames = frames.concat(Array.prototype.slice.call(root.querySelectorAll('iframe')));
    } catch (e) {}
    frames.forEach(maybeHideCornerIframe);
  }

  function inspect(scope) {
    hideKnown(scope || document);
    inspectIframes(scope || document);
  }

  function init() {
    if (!onTargetPage()) return;
    inspect(document);

    /* Chat apps commonly inject after load or apply iframe sizing a moment later.
       A few delayed iframe-only checks are cheap and do not mutate the product UI. */
    [250, 1000, 2500, 5000].forEach(function (delay) {
      setTimeout(function () { inspectIframes(document); hideKnown(document); }, delay);
    });

    if (window.MutationObserver && document.body) {
      var observer = new MutationObserver(function (records) {
        if (!onTargetPage()) return;
        records.forEach(function (record) {
          Array.prototype.slice.call(record.addedNodes || []).forEach(function (node) {
            if (!node || node.nodeType !== 1) return;
            hideKnown(node);
            inspectIframes(node);
            /* Let newly-added iframes receive their final fixed dimensions first. */
            setTimeout(function () { inspectIframes(node); }, 400);
          });
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* Stage 7U: disable legacy ElevateZoom touch capture on mobile product pages.
   ElevateZoom binds touchmove directly to the main product image and calls preventDefault(),
   so swiping over the image cannot scroll the page on a real phone. */
(function () {
  'use strict';

  var MQ = '(max-width: 991px)';

  function isConfiguratorPage() {
    return !!document.querySelector('.ll-product-configurator-page, [data-ll-configurator]');
  }

  function disableMobileGalleryZoom() {
    if (!window.matchMedia || !window.matchMedia(MQ).matches || !isConfiguratorPage()) return;

    var selector = '.ll-configurator-media .detail-gallery .mid img';
    var images = Array.prototype.slice.call(document.querySelectorAll(selector));

    images.forEach(function (img) {
      if (!img) return;
      img.style.setProperty('touch-action', 'pan-y', 'important');
      img.style.setProperty('-ms-touch-action', 'pan-y', 'important');

      if (window.jQuery) {
        var $img = window.jQuery(img);
        try {
          var zoom = $img.data('elevateZoom');
          if (zoom && typeof zoom.destroy === 'function') zoom.destroy();
        } catch (e) {}

        /* The legacy plugin registers these without a namespace. The product image has no
           mobile drag interaction of its own, so removing its touch handlers is intentional. */
        try { $img.off('touchmove touchstart touchend'); } catch (e) {}
        try { $img.removeData('elevateZoom'); } catch (e) {}
      }
    });

    /* Zoom overlays are appended to <body> and have their own preventDefault touch handler. */
    Array.prototype.slice.call(document.querySelectorAll('.zoomContainer')).forEach(function (node) {
      try { node.parentNode && node.parentNode.removeChild(node); } catch (e) {}
    });
  }

  function scheduleDisable() {
    disableMobileGalleryZoom();
    [50, 250, 750, 1500, 3000].forEach(function (delay) {
      setTimeout(disableMobileGalleryZoom, delay);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleDisable);
  else scheduleDisable();

  window.addEventListener('load', scheduleDisable);
  window.addEventListener('resize', function () { setTimeout(disableMobileGalleryZoom, 80); });

  // Stage 7AZ: robust direct tap/click selection for light-base cards.
  // The visual redesign in 7AY made the image fill the card, which exposed an old
  // event-order problem: clicks landing on inner image/text nodes could be consumed
  // by carousel/drag handlers before the radio/label behavior completed.
  document.addEventListener('click', function(event) {
    var card = event.target && event.target.closest
      ? event.target.closest('[data-ll-base-card]')
      : null;
    if (!card) return;

    var root = card.closest('[data-ll-configurator]');
    if (!root) return;

    var input = card.querySelector('input[type="radio"], input[type="checkbox"]');
    if (!input || input.disabled) return;

    // Do not double-toggle if the native input itself was the click target.
    if (event.target !== input) {
      event.preventDefault();
    }

    var noneInput = root.querySelector('[data-ll-lightbase-none-input]');
    if (noneInput && noneInput !== input) noneInput.checked = false;

    if (!input.checked) {
      input.checked = true;
    }

    // Always dispatch the same change event used by arrows/programmatic selection,
    // ensuring price, selected state, compatibility, and total all update together.
    input.dispatchEvent(new Event('change', { bubbles: true }));

    // Update visible selected state immediately for responsiveness.
    var grid = card.closest('.ll-cfg-base-grid');
    if (grid) {
      grid.querySelectorAll('[data-ll-base-card]').forEach(function(other) {
        other.classList.toggle('is-selected', other === card);
      });
    }
  }, true);

  document.addEventListener('touchend', function(event) {
    var card = event.target && event.target.closest
      ? event.target.closest('[data-ll-base-card]')
      : null;
    if (!card) return;

    var root = card.closest('[data-ll-configurator]');
    if (!root) return;

    var input = card.querySelector('input[type="radio"], input[type="checkbox"]');
    if (!input || input.disabled || input.checked) return;

    // Let the following synthetic click handle normal taps where possible.
    // This branch exists only as a fallback for mobile browsers that suppress it.
    setTimeout(function() {
      if (!input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        var grid = card.closest('.ll-cfg-base-grid');
        if (grid) {
          grid.querySelectorAll('[data-ll-base-card]').forEach(function(other) {
            other.classList.toggle('is-selected', other === card);
          });
        }
      }
    }, 0);
  }, { capture: true, passive: true });

})();
